<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId">
        <!-- eslint-disable -->
        <textarea
            :id="formControlId"
            :name="formControlId"
            style="display: none;"
            @change="handleChange">
            {{ data[property] }}
        </textarea>
        <!-- eslint-enable -->
        <csp-ckeditor :textarea-id="formControlId"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from './FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            type: {
                type: String,
                default: 'text',
            },
            max: {
                type: Number,
                default: null,
            },
            nullIfEmpty: {
                type: Boolean,
                default: false,
            },
            rows: {
                type: Number,
                default: 3,
            },
            maxRows: {
                type: Number,
                default: 3,
            },
        },
        computed: {
            text() {
                return this.data[this.property];
            },
        },
        methods: {
            handleChange() {
                const element = document.querySelector('#' + this.formControlId);
                this.data[this.property] = element.textContent;
            },
        },
    }
</script>
